
const digest = '9802a51d2ad8e1c59efa2cdbb83e659df8d6133cbc35abc4dda361d37dd82222';
const classes = {"masterWrapper":"_masterWrapper_1vhfq_1","noGap":"_noGap_1vhfq_8","wrapper":"_wrapper_1vhfq_12","calendarPicker":"_calendarPicker_1vhfq_21","filter":"_filter_1vhfq_24","controls":"_controls_1vhfq_30","hidden":"_hidden_1vhfq_42","toggleBar":"_toggleBar_1vhfq_46","toggleButton":"_toggleButton_1vhfq_50","open":"_open_1vhfq_60","close":"_close_1vhfq_64"};
const css = `._masterWrapper_1vhfq_1 {
  display: flex;
  flex-direction: column;
  position: relative;
  margin-bottom: 5px;
}

._noGap_1vhfq_8 {
  margin-bottom: 0;
}

._wrapper_1vhfq_12 {
  display: flex;
  gap: 24px;
  background-color: #fff;
  border: 1px solid #eaedf3;
  align-items: center;
  height: 100%;
  position: relative;
}
._wrapper_1vhfq_12 ._calendarPicker_1vhfq_21 {
  position: relative;
}
._wrapper_1vhfq_12 ._filter_1vhfq_24 {
  padding: 24px;
  display: flex;
  flex: 1;
  flex-direction: column;
}
._wrapper_1vhfq_12 ._controls_1vhfq_30 {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 24px;
  border-left: 1px solid #eaedf3;
  align-items: flex-start;
  justify-content: center;
  min-width: fit-content;
  height: 100%;
}

._hidden_1vhfq_42 {
  display: none;
}

._toggleBar_1vhfq_46 {
  display: flex;
  justify-content: flex-end;
}
._toggleBar_1vhfq_46 ._toggleButton_1vhfq_50 {
  color: #fff;
  padding: 5px 12px 5px 29px;
  display: block;
  border: 1px solid #eaedf4;
  border-bottom: 0;
  border-radius: 5px 5px 0 0;
  text-decoration: none;
  font-size: 12px;
}
._toggleBar_1vhfq_46 ._open_1vhfq_60 {
  background: #074277 url(/dist/icons/v2/chevron-down.svg) no-repeat left 10px center;
  background-size: 12px;
}
._toggleBar_1vhfq_46 ._close_1vhfq_64 {
  background: #074277 url(/dist/icons/v2/chevron-up.svg) no-repeat left 10px center;
  background-size: 12px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  